import { render } from "./Dynamic.view.vue?vue&type=template&id=12c84c59"
import script from "./Dynamic.view.vue?vue&type=script&lang=js"
export * from "./Dynamic.view.vue?vue&type=script&lang=js"

import "./Dynamic.view.vue?vue&type=style&index=0&id=12c84c59&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__